
import React from 'react';
import Layout from "@/components/Layout";
import PartnerHero from "@/components/partner/PartnerHero";
import PartnerProblem from "@/components/partner/PartnerProblem";
import PartnerSolution from "@/components/partner/PartnerSolution";
import PartnerBenefits from "@/components/partner/PartnerBenefits";
import PartnerResults from "@/components/partner/PartnerResults";
import PartnerProcess from "@/components/partner/PartnerProcess";
import PartnerComparison from "@/components/partner/PartnerComparison";
import PartnerTargetAudience from "@/components/partner/PartnerTargetAudience";
import PartnerFounderOffer from "@/components/partner/PartnerFounderOffer";
import PartnerCTA from "@/components/partner/PartnerCTA";

const Partner = () => {
  return (
    <Layout>
      <PartnerHero />
      <PartnerProblem />
      <PartnerSolution />
      <PartnerBenefits />
      <PartnerResults />
      <PartnerProcess />
      <PartnerComparison />
      <PartnerTargetAudience />
      <PartnerFounderOffer />
      <PartnerCTA />
    </Layout>
  );
};

export default Partner;
